import { addLocaleData } from 'react-intl';
import pt from 'react-intl/locale-data/pt';

export const DEFAULT_LOCALE = 'pt-BR';

export function configureReactIntlPolyfill(renderCallback) {
  if (window.Intl) {
    configureLocale(renderCallback);
    return;
  }

  Promise.all([
    import('intl'),
    import('intl/locale-data/jsonp/pt.js')
  ]).then(() => {
    configureLocale(renderCallback);
  });
  
}

function configureLocale(renderCallback) {
  addLocaleData(pt);
  renderCallback();
}

export function getIntlProviderConfig(msgs) {
  return { locale: getLocale(), messages: msgs || {} };
}

const getLocale = () => {
  return (navigator.languages && navigator.languages[0])
    || navigator.language
    || navigator.userLanguage
    || DEFAULT_LOCALE;
};